import React, { Component } from "react";
import styles from "./Prompt.module.scss"
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import { withRouter } from "react-router-dom";

var classNames = require("classnames");

class Prompt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
    };
  }

  componentWillUnmount() {
    this.setState({ showPopup: false });
  }

  render() {
    if (this.props.isVisible) {
      document.body.classList.add("popup-mode");
    } else {
      document.body.classList.remove("popup-mode");
    }

    let CloseAlertControls = classNames(
      "tileBg2 " + styles.closeAlertControls,
      this.props.className,
      {
        [styles.visible]: this.props.isVisible,
      }
    );

    let DarkMask = classNames(styles.darkMask, this.props.className, {
      [styles.visible]: this.props.isVisible,
    });

    return (
      <Wrapper>
        <div>
          <div className={CloseAlertControls}>
            <div className={styles.content}>
              <div className={styles.spanButtons}>
                <span>{this.props.titleText}</span>
                <button
                  className="closeAlertControls__btn -close"
                  onClick={this.props.onClose}
                >
                </button>
              </div>
              <div className={styles.section}>
              <span className={styles.subtitleText}>
                {this.props?.subtitleText}
              </span>
              </div>

              <div className={styles.spanButtons + " " + styles.bottom}>
                {this.props.buttons}
              </div>
            </div>
          </div>
          <div className={DarkMask} />
        </div>
      </Wrapper>
    );
  }
}

export default withRouter(Prompt);
